import {isRouteErrorResponse, useRouteError} from "react-router";
import ErrorFallback from "./ErrorFallback";

/**
 * Normalizes whatever react-router hands us (Error, ErrorResponse, string,
 * anything thrown) into an Error so ErrorFallback can render it.
 */
const toError = (value: unknown): Error => {
    if (value instanceof Error) {
        return value;
    }
    if (isRouteErrorResponse(value)) {
        return new Error(`${value.status} ${value.statusText}`);
    }
    if (typeof value === "string") {
        return new Error(value);
    }
    try {
        return new Error(JSON.stringify(value));
    } catch {
        return new Error(String(value));
    }
};

/**
 * Route-level error element (ticket #55833): replaces React Router's built-in
 * "Unexpected Application Error!" / "Hey developer" page with the branded,
 * translated ErrorFallback for any error thrown while rendering a route.
 */
const RouteErrorFallback = () => {
    const error = useRouteError();
    return <ErrorFallback error={toError(error)} showBaseNotice/>;
};

export default RouteErrorFallback;
